import axiosInstance from "@/services/http/axios-instance";

export class TokenizationApi {
  getCards(locale = "uk") {
    return axiosInstance.get(`/tokenization/cards?language=${locale}`);
  }
}
